export const COMPANY_DOCUMENT_DROP_DOWN_ITEMS = []